export enum NotificationTextUsage {
  PUSH_TITLE = 'PUSH_TITLE',
  PUSH_BODY = 'PUSH_BODY',
  EMAIL_SUBJECT = 'EMAIL_SUBJECT',
  EMAIL_BODY = 'EMAIL_BODY',
  SMS = 'SMS',
  ALERT_TITLE = 'ALERT_TITLE',
  ALERT_BODY = 'ALERT_BODY',
}
